const ADMIN_API =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_ADMIN_API_BASE) ||
  process.env.REACT_APP_ADMIN_API_BASE ||
  "https://identity.wassiniluxury.com/api";

// Same key AuthContext stores the logged-in admin under
const AUTH_STORAGE_KEY = "authUser";

function getAdminToken() {
  try {
    const stored = window.localStorage.getItem(AUTH_STORAGE_KEY);
    return stored ? JSON.parse(stored)?.token : null;
  } catch (error) {
    return null;
  }
}

async function fetchAdminJson(path, options = {}) {
  const url = path.startsWith("http") ? path : `${ADMIN_API}${path}`;
  const token = getAdminToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const response = await fetch(url, { ...options, headers });
  const contentType = response.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");

  if (response.status === 401 || response.status === 403) {
    // Missing, expired or pre-update token: identity only accepts admin requests with a valid token
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    window.location.assign("/login");
    throw new Error("Your session has expired. Please log in again.");
  }

  if (!response.ok) {
    const errorText = isJson ? (await response.json())?.message : await response.text();
    throw new Error(errorText || `HTTP ${response.status}`);
  }

  return isJson ? response.json() : response.text();
}

export { ADMIN_API, fetchAdminJson };
